import { TABS, type Tab } from "@/pages/Rounds/constant";
import { cn } from "@roman/shared/utils";

type SelectRoundTab = {
  selectedTab: Tab;
  setSelectedTab: (tab: Tab) => void;
};

const SelectRoundTab: React.FC<SelectRoundTab> = ({ selectedTab, setSelectedTab }) => {
  return (
    <div className="flex w-full h-[50px] gap-0">
      {TABS.map((tab) => {
        const isSelectedTab = selectedTab.type === tab.type;

        return (
          <div
            key={tab.type}
            className={cn("w-full flex border-b-[5px]", isSelectedTab ? "border-b-primary" : "border-b-transparent")}
          >
            <div
              className={cn(
                "flex items-center hover:cursor-pointer justify-center flex-1 text-[14px]",
                isSelectedTab ? "font-bold text-primary" : "font-bold text-[#808080]",
              )}
              onClick={() => setSelectedTab(tab)}
            >
              <p className="text-center whitespace-nowrap text-[14px] font-bold tracking-[0.56px]">
                {tab.title.split("\n").flatMap((line) => (
                  <span key={line}>
                    {line}
                    <wbr />
                  </span>
                ))}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SelectRoundTab;
